module.exports = __webpack_public_path__ + "img/visible-on.042ed593.svg";